import { InReviewQuestionListType } from '../../firebase/firestore/documents/candidate';

export type RecruiterTodoListHeaderType = {
  action: string;
  lastStatus: string;
  status: string;
  locationAndPosition: string;
  candidateName: string;
};

export type RecruiterTodoListDataType = {
  id: string;
  actionType: ActionEnum;
  title: string;
  description: string;
  lastStatus: string;
  status: string;
  location: string;
  position: string;
  candidateFullName: string;
  candidateId: string;
  customName: string;
  todoStatus: string;
  category: string;
  helpRequestedMessages?: {
    userType: 'seeker' | 'recruiter';
    message: string;
    timestamp: Date;
    name: string;
  }[];
  latestHelpRequestedFor?: string;
  hireDetailsRequestedAt?: string;
  hireDetailsStatus?: string;
  seekerHireDetailId?: string;
  statusAssignedBy?: TodoStatusAssignedByType;
  statusAssignedRecruiter: string;
  inReviewQuestionList?: InReviewQuestionListType;
  monetized?: boolean;
  offerAcceptanceStatus?: {
    offerAccepted: boolean;
    reason: string;
    customReason: string;
  };
  latestHelpRequestedLabel?: Record<string, string>;
  hireFormTemplate?: {
    defaultLanguage: string;
    languages: string[];
  };
  hireFormTemplateId?: string;
  isSeekerPreviouslyMonetized?: boolean;
};

export type TodoStatusAssignedByType = {
  recruiterName: string;
  recruiterId: string;
};

export enum ActionEnum {
  BACKGROUND_CHECK,
  HIRE_FORM,
  OFFER,
  LANGUAGE_EVALUATION,
  CONVERSATIONAL_AI,
  OTHER,
  I9_VERIFICATION,
  REVIEW_ANSWERS,
  OFFER_REJECTED,
  OFFER_EXPIRED,
  OFFER_ACCEPTED,
  UPCOMING_INTERVIEWS,
}

export enum StatusEnum {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
